var _style, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandSchildGroen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 271.1 295.2",
    style: {
      enableBackground: "new 0 0 271.1 295.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#F5AD84;}\r\n\t.st2{opacity:0.5;fill:#DC6A61;enable-background:new    ;}\r\n\t.st3{fill:#184785;}\r\n\t.st4{opacity:0.2;}\r\n\t.st5{fill:#DC6A61;}\r\n\t.st6{opacity:0.2;fill:#DC6A61;enable-background:new    ;}\r\n\t.st7{opacity:0.4;fill:#DC6A61;enable-background:new    ;}\r\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#81E247;}\r\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#53A022;}\r\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 135.3,
    cy: 159.8,
    r: 135.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.6,93.9c-10.9,9.7-21.6,18.1-26,21.6c-1.4,1.1-2.1,1.7-2.1,1.7l-17.7-17.7c0,0,4.6-4,11.6-9.7 c8.7-7.1,21.1-16.8,32.7-24.6c13.1-8.8,25.1-15.1,29.7-12.4C277.8,58.1,258.9,77.7,240.6,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240.6,93.9c-10.9,9.7-21.6,18.1-26,21.6l-8.2-25.7c7.5-6.1,27.9-21.3,27.9-21.3L240.6,93.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.1,248.5c0,0-4.1,4.2-17.5,14.9c-13,10.2-34.5,31-44.4,28.5C50.8,282.2,20.5,230,20.5,230l108.3-7.9 l5.3,3.6L168.1,248.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M168.1,248.5c0,0-4.1,4.2-17.5,14.9c-12.8-6.8-30.2-10.5-30.2-10.5l7.7-24.8l6-2.3L168.1,248.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M221.7,252.5H111.2c-7.3,0-13.3-5.9-13.3-13.3V13.3C98,5.9,103.9,0,111.2,0h110.5C229,0,235,5.9,235,13.3 v226C235,246.5,229,252.5,221.7,252.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.2,
    y: 15.4,
    className: "st0",
    width: 124.6,
    height: 224.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M228.8,126.5v22.8c-3.3-1.8-6.3-5.9-6.3-11.2C222.5,133,225.5,128.6,228.8,126.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M228.8,167.7v22.1c-3-2-5.7-5.9-5.7-10.9C223.1,174.1,225.7,169.9,228.8,167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M228.8,190.1v20.2c-3-1.5-5.7-4.6-5.7-9.2C223.1,196.2,225.7,192.1,228.8,190.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M133.8,240.2h-29.6V108.5c4.6,14.2,6.3,42.4,7.3,58c0.2,2.6,0.8,5.1,1.9,7.4 C117.6,183.4,129.5,211.4,133.8,240.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.8,10.5H152c-1.5,0-2.8-1.2-2.8-2.8l0,0c0-1.5,1.2-2.8,2.8-2.8h28.8c1.5,0,2.8,1.2,2.8,2.8l0,0 C183.6,9.3,182.4,10.5,180.8,10.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 206.3,
    cy: 7.7,
    r: 2.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.5,252.8l-37.2,29.4L20.5,230c0,0,2.8-1.8,12.5-11c11.2-10.6,24.7-25.8,31.4-42.2 c10.2-25.1,15.3-57.5,18.3-80.1c1-7.5,1.8-13.9,2.5-18.5c0-0.3,0.1-0.5,0.2-0.8c1.4-5.5,8.9-7.1,12.3-2.2 c8.4,12,7.6,43.1,8.1,96.6C105.8,171.8,120.1,210.2,120.5,252.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M82.8,96.7c1-7.5,1.8-13.9,2.5-18.5c0-0.3,0.1-0.5,0.2-0.8c2.5-0.4,5.2,0.3,5.2,7.4 C90.6,94.3,92.2,97.5,82.8,96.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.2,137.4c-0.4,7.4-6.8,11.8-11,11.8s-9.7-5.2-9.7-12.7c0-7.4,5.9-13.4,10.1-13.4 C239.8,123.1,246.7,127.7,246.2,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.8,179.7c-0.4,7.4-6.8,11.8-11,11.8s-9.7-5.2-9.7-12.7s5.9-13.4,10.1-13.4 C240.4,165.4,247.3,170,246.8,179.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.2,202.8c-0.7,5.8-5,9.8-9,9.8s-10.1-3.5-10.1-10.8c0-7.2,5.6-12.9,9.7-12.9S246,196.2,245.2,202.8z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shape_1_copy_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M167.3,54.7l-41.1,16.1c0,0,0,13,0,45.1s40.3,48.4,40.3,48.4s0.6-0.3,1.6-0.8V55.1L167.3,54.7z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Shape_1_copy_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M169,54.7l-0.8,0.3v108.5c1,0.5,1.6,0.8,1.6,0.8s40.3-16.2,40.3-48.4s0-45.1,0-45.1L169,54.7z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Shape_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "185.1,87 162.5,109.5 152,99.1 141.5,109.5 161.7,130.5 194.7,97.5  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandSchildGroen);
export default __webpack_public_path__ + "static/media/hand-schild-groen.8b0024cfcdff3a1843ebf7bd455377a0.svg";
export { ForwardRef as ReactComponent };